export default __webpack_public_path__ + "static/media/ic_success.7ad116f7.svg";